<template lang='pug'>
  #app
    Header(v-if="!estaNaRotaDeAcessoNegado")
    router-view

    .sso-loading(v-if="executingSAMLLogin")
      h1 Realizando login por SSO...

    Footer(v-if="!estaNaRotaDeAcessoNegado")
</template>

<script>
import Header from '@/components/Header/Header.vue'
import Footer from '@/components/Footer/Footer.vue'
import Cookies from 'js-cookie'

export default {
  components: {
    Header,
    Footer
  },
  async beforeMount () {
    // fetch default styles we will use they if this device is not registred yet
    await this.$store.dispatch('getVisual', {forceReload:true})

    // the idea here is to only update browserRecord info if user reload the page
    if (this.$store.state.accessData.browserRecord || Cookies.get('id_browser')) {
      await this.$store.dispatch('getBrowserRecordInfo')
    }
  },
  computed: {
    executingSAMLLogin () {
      return this.$store.state.executingSAMLLogin
    },
    estaNaRotaDeAcessoNegado () {
      return this.$route.name === 'AcessoNegado'
    }
  }
}
</script>

<style>
#app {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: fit-content(120px) auto 100px;
  height: 100%;
}
input[type=tel] {
  -webkit-text-security: disc!important;
}
.sso-loading {
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
}
</style>
